import { persisterDexieStorage } from '@connected/api-client/lib/persister';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

export const localStoragePersister = createAsyncStoragePersister({
    storage: persisterDexieStorage,
});
